// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__Mx_rn","empty":"ModalGraph_empty__4ASRQ"};